import { VERTICAL_BAR_WITH_SPACES } from "./str";

type Identifiable<T = unknown> = {
  id: T;
};

async function wait(time: number) {
  await new Promise((resolve) => setTimeout(resolve, time));
}

function definePageTitle(companyName: string, title: string) {
  return [companyName, ...(title.length > 0 ? [title] : [])].join(VERTICAL_BAR_WITH_SPACES);
}

function boolToStr(value: boolean) {
  return value ? "true" : "false";
}

export { iife } from "@workspace/core";
export { boolToStr, definePageTitle, wait };
export type { Identifiable };
